export default "__VITE_ASSET__BuY6wGCx__"